(function () {
  "use strict";

  var root = document.querySelector("[data-gs-price-calculator]");
  if (!root) return;

  var configNode = root.querySelector("[data-gs-price-calculator-config]");
  var config;
  try {
    config = JSON.parse(configNode && configNode.textContent || "{}");
  } catch (error) {
    return;
  }

  var variants = Array.isArray(config.variants) ? config.variants : [];
  var sizes = Array.isArray(config.sizes) ? config.sizes : [];
  var methods = config.methods || {};
  var hasMethods = Boolean(methods.standardValue && methods.vividValue);
  if (!variants.length || !sizes.length) return;

  var state = {
    method: methods.defaultValue || methods.standardValue || variants[0].method || "",
    size: sizes[0],
    quantity: 1
  };

  var dialog = document.createElement("dialog");
  dialog.className = "bsv4-calc-modal gs-calc-modal";
  dialog.setAttribute("aria-labelledby", "gs-calc-title");
  dialog.innerHTML = [
    '<div class="bsv4-calc__card">',
      '<header class="bsv4-calc__head">',
        '<h2 class="bsv4-calc__title" id="gs-calc-title">Price Calculator</h2>',
        '<button type="button" class="bsv4-calc__x" data-gs-calc-close aria-label="Close">&times;</button>',
      '</header>',
      hasMethods ? '<fieldset class="bsv4-calc__methods">' : '',
      hasMethods ? [
        '<legend class="bsv4-calc__methodsLegend">Print method</legend>',
        methodControl(methods.vividValue, methods.vividLabel || "Vivid AF 9 Colour"),
        methodControl(methods.standardValue, methods.standardLabel || "Standard 5 Colour"),
      '</fieldset>'
      ].join("") : '',
      '<fieldset class="gs-calc__sizes">',
        '<legend class="bsv4-calc__methodsLegend">Gang sheet size</legend>',
        '<div class="gs-calc__sizeGrid" data-gs-calc-sizes></div>',
      '</fieldset>',
      '<div class="bsv4-calc__cell gs-calc__quantity">',
        '<div class="bsv4-calc__sublabel">Quantity</div>',
        '<div class="bsv4-calc__stepper">',
          '<button type="button" class="bsv4-calc__step" data-gs-calc-step="-1" aria-label="Decrease quantity">&minus;</button>',
          '<input type="number" class="bsv4-calc__input" min="1" step="1" value="1" inputmode="numeric" data-gs-calc-quantity>',
          '<button type="button" class="bsv4-calc__step" data-gs-calc-step="1" aria-label="Increase quantity">+</button>',
        '</div>',
      '</div>',
      '<div class="gs-calc__summary">',
        '<div><span>Per sheet</span><strong data-gs-calc-each>£0.00</strong></div>',
        '<div><span>Total</span><strong data-gs-calc-total>£0.00</strong></div>',
      '</div>',
      '<button type="button" class="bsv4-btn bsv4-btn--primary bsv4-calc__cta" data-gs-calc-continue>Upload your gang sheet</button>',
    '</div>'
  ].join("");
  root.appendChild(dialog);

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character];
    });
  }

  function methodControl(value, label) {
    var checked = state.method === value ? " checked" : "";
    return '<label class="bsv4-calc__method"><input type="radio" name="gs-calc-method" value="' + escapeHtml(value) + '" data-gs-calc-method' + checked + '><span>' + escapeHtml(label) + '</span></label>';
  }

  function matchingVariant(size, method) {
    return variants.find(function (variant) {
      var sizeMatches = variant.size === (size || state.size);
      var methodMatches = !hasMethods || variant.method === (method || state.method);
      return sizeMatches && methodMatches;
    });
  }

  function sizeMetres(size) {
    var match = String(size).match(/[\d.]+/);
    return match ? Number(match[0]) : 0;
  }

  function bulkSaving(size, price) {
    var firstSize = sizes[0];
    var firstVariant = matchingVariant(firstSize, state.method);
    var firstMetres = sizeMetres(firstSize);
    var metres = sizeMetres(size);
    if (!firstVariant || !firstMetres || !metres || !price) return 0;
    var fullPrice = (Number(firstVariant.price) / firstMetres) * metres;
    return Math.max(0, Math.round((1 - Number(price) / fullPrice) * 100));
  }

  function sizeControl(size) {
    var variant = matchingVariant(size, state.method);
    var price = variant ? Number(variant.price) : 0;
    var saving = bulkSaving(size, price);
    var active = size === state.size;
    return [
      '<button type="button" class="gs-calc__size' + (active ? ' is-active' : '') + '" data-gs-calc-size="' + escapeHtml(size) + '" aria-pressed="' + active + '">',
        '<span class="gs-calc__sizeLabel">' + escapeHtml(size) + '</span>',
        '<span class="gs-calc__sizePrice">' + money(price) + '</span>',
        saving > 0 ? '<span class="gs-calc__sizeSaving">' + saving + '% off</span>' : '',
      '</button>'
    ].join("");
  }

  function money(cents) {
    return "£" + ((Number(cents) || 0) / 100).toFixed(2);
  }

  function render() {
    var variant = matchingVariant();
    var each = variant ? Number(variant.price) : 0;
    dialog.querySelector("[data-gs-calc-sizes]").innerHTML = sizes.map(sizeControl).join("");
    dialog.querySelector("[data-gs-calc-each]").textContent = money(each);
    dialog.querySelector("[data-gs-calc-total]").textContent = money(each * state.quantity);
  }

  function openCalculator() {
    if (!dialog.open) dialog.showModal();
    render();
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest && event.target.closest("a.pricingTable, ._price-calc-link, .openPriceCalculator");
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openCalculator();
  }, true);

  dialog.addEventListener("click", function (event) {
    if (event.target === dialog || event.target.closest("[data-gs-calc-close]")) {
      dialog.close();
      return;
    }
    var step = event.target.closest("[data-gs-calc-step]");
    if (step) {
      state.quantity = Math.max(1, state.quantity + Number(step.dataset.gsCalcStep || 0));
      dialog.querySelector("[data-gs-calc-quantity]").value = state.quantity;
      render();
      return;
    }
    var size = event.target.closest("[data-gs-calc-size]");
    if (size) {
      state.size = size.dataset.gsCalcSize;
      render();
      return;
    }
    if (event.target.closest("[data-gs-calc-continue]")) {
      dialog.close();
      var upload = document.querySelector(".dtfut, file-upload, [data-fileupload]");
      if (upload) upload.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  function handleFieldChange(event) {
    if (event.target.matches("[data-gs-calc-method]")) state.method = event.target.value;
    if (event.target.matches("[data-gs-calc-quantity]")) {
      state.quantity = Math.max(1, Math.round(Number(event.target.value) || 1));
      event.target.value = state.quantity;
    }
    render();
  }

  dialog.addEventListener("input", handleFieldChange);
  dialog.addEventListener("change", handleFieldChange);

  render();
})();
